const FLUTTER_IFRAME_WRAPPER_MAP = {
  'deals_home': "#flutter_homepage_deals_widget_wrapper",
  'deals_explore': "#flutter_deals_exploration_widget",
  'vouchers': "#flutter_gift_voucher_widget",
  'preview_panel': "#flutter_preview_frame_wrapper",
  'accommodation_single_listing': "#flutter_accommodation_single_widget_wrapper",
  'checkout' : '#flutter_checkout_widget'

};

export { FLUTTER_IFRAME_WRAPPER_MAP };
